import { render, staticRenderFns } from "./auditoriumsEdition.vue?vue&type=template&id=62c16d7a"
import script from "./auditoriumsEdition.vue?vue&type=script&lang=js"
export * from "./auditoriumsEdition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports